import { useSnapshot } from 'valtio';

import type { FileAttachment } from '../../../providers/AIContext';
import { userTempInventoryState, removeFromUserTempInventory } from '@/storage';

export function useAttachments() {
    const userTempInventory = useSnapshot(userTempInventoryState);
    const attachments = userTempInventory.files as FileAttachment[];

    const removeAttachment = async (att: FileAttachment) => {
        await removeFromUserTempInventory(att.fileFolder);
    };

    const removeAllAttachments = async () => {
        const folders = attachments.map((a) => a.fileFolder);
        await Promise.all(folders.map((f) => removeFromUserTempInventory(f)));
    };

    return { attachments, removeAttachment, removeAllAttachments };
}
